import {
  useDismissWhatsAppReminder,
  useGetMyWhatsAppGroups,
  useSetWhatsAppGroupJoined,
} from '@actions';
import WhatsAppGroupsModal from './WhatsAppGroupsModal';

const MentorWhatsAppGroupsModal = () => {
  const { data, isLoading } = useGetMyWhatsAppGroups();
  const { mutate: setJoined, isLoading: isSaving } = useSetWhatsAppGroupJoined();
  const { mutate: dismiss } = useDismissWhatsAppReminder();

  return (
    <WhatsAppGroupsModal
      title="Join your students' WhatsApp groups"
      description="Each student has a WhatsApp group with their parent. Open the groups you have not joined yet and tick them off; we will remind you about the rest next week."
      groups={data?.students ?? []}
      dismissedAt={data?.dismissedAt}
      isLoading={isLoading || !data}
      isSaving={isSaving}
      onToggleJoined={(studentId, joined) => setJoined({ studentId, joined })}
      onDismiss={() => dismiss({})}
    />
  );
};

export default MentorWhatsAppGroupsModal;
